// src/components/Experiments/ExperimentRow.jsx
// Компактная строчная карточка эксперимента (step5) — второй вид отображения
// в ExperimentsPage.js (viewMode === 'row'). Пропсы идентичны ExperimentCard,
// чтобы компонент подставлялся в тот же .map() без адаптеров.
import React from 'react';
import { formatDate } from '../../utils/date';
import './ExperimentRow.css';

const ExperimentRow = ({
  experiment,
  onClick,
  selectionMode = false,
  isSelected = false,
  onToggleSelect,
  showOwnerBadge = true,
  showGroupBadges = false,
}) => {
  const isOwner = experiment.is_owner ?? true;
  const groups = experiment.shared_groups ?? [];

  const handleClick = (e) => {
    if (selectionMode && onToggleSelect) {
      e.stopPropagation();
      onToggleSelect();
    } else if (onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (selectionMode && onToggleSelect) {
        onToggleSelect();
      } else if (onClick) {
        onClick();
      }
    }
  };

  const groupTitle = groups.map(g => g.name).join(', ');

  return (
    <div
      className={`exp-row ${isSelected ? 'exp-row--selected' : ''} ${selectionMode ? 'exp-row--selectable' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={selectionMode ? 'checkbox' : 'button'}
      aria-checked={selectionMode ? isSelected : undefined}
      tabIndex={0}
    >
      {selectionMode && (
        <span className="exp-row__checkbox">
          {isSelected ? (
            <i className="bi bi-check-circle-fill text-primary" />
          ) : (
            <i className="bi bi-circle text-muted" />
          )}
        </span>
      )}

      <span className="exp-row__name" title={experiment.name}>
        {experiment.name}
      </span>

      {showOwnerBadge && !isOwner && (
        <span className="exp-row__shared-badge">
          <i className="bi bi-share-fill me-1" />
          Shared
        </span>
      )}

      {showGroupBadges && groups.length > 0 && (
        <span className="exp-row__group-chip" title={groupTitle}>
          <i className="bi bi-people-fill me-1" />
          {groups[0].name}
          {groups.length > 1 && (
            <span className="exp-row__group-chip-more">+{groups.length - 1}</span>
          )}
        </span>
      )}

      <span className="exp-row__date">{formatDate(experiment.created_at)}</span>
    </div>
  );
};

export default ExperimentRow;
